import { cdnWebSocketTransimissionValidator } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";
import { eventChannel } from "redux-saga";
let socket = null;

export const initWebSocket = (filters, token) =>
    eventChannel(emitter => {
        socket = new WebSocket(
            `${cdnWebSocketTransimissionValidator}?access_token=${token}&${makeQuery(filters)}&source=web`,
            "protocolOne"
        );

        socket.onmessage = event => {
            const messageData = JSON.parse(event.data);
            return emitter({ data: messageData });
        };

        socket.onclose = event => {
            console.error(event);
            return emitter({ event: event });
        };

        socket.onerror = error => {
            console.error("error", error);
            return emitter({ error: error });
        };

        return () => {
            console.log("Socket off");
            closeWebSocket();
        };
    });

export const closeWebSocket = () => {
    if (socket) {
        console.log("Socket off");
        socket.onclose = () => {};
        socket.close();
        socket = null;
    }
};
